import styled from 'styled-components';
import {
  GRAPHITE_COLOR,
  ICE_COLOR,
  LG_COLOR,
  MAIN_BLUE_COLOR,
  PLATINUM_COLOR,
  SOFT_GREY_COLOR,
} from 'containers/App/constants';

export const AdsureMonitoringStyles = styled.div`
  background: ${ICE_COLOR};
  min-height: 100%;
  padding: 24px;

  .adsure-monitoring-shell {
    margin: 0 auto;
    max-width: 1400px;
  }

  .adsure-monitoring-header,
  .adsure-panel {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 8px 22px rgba(65, 70, 80, 0.08);
  }

  .adsure-monitoring-header {
    margin-bottom: 18px;
    padding: 22px 24px;
  }

  .adsure-monitoring-eyebrow {
    color: ${LG_COLOR};
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  .adsure-monitoring-title {
    color: ${GRAPHITE_COLOR};
    font-size: 1.65rem;
    font-weight: 600;
    line-height: 1.25;
    margin: 0;
  }

  .adsure-monitoring-subtitle {
    color: #66707d;
    margin: 8px 0 0;
    max-width: 760px;
  }

  .adsure-header-controls {
    align-items: stretch;
    display: flex;
    gap: 18px;
  }

  .adsure-header-metric {
    border-left: 1px solid ${PLATINUM_COLOR};
    min-width: 210px;
    padding-left: 24px;
  }

  .adsure-header-metric-value {
    color: ${MAIN_BLUE_COLOR};
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
  }

  .adsure-header-metric-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .adsure-mosaic-control {
    background: #f8f9fb;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    min-width: 300px;
    padding: 14px 16px;
  }

  .adsure-mosaic-control-copy {
    color: #66707d;
    font-size: 0.84rem;
    line-height: 1.35;
    max-width: 230px;
  }

  .adsure-mosaic-toggle-row {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    margin-top: 14px;
  }

  .adsure-mosaic-toggle-row .form-check {
    margin: 0;
    min-height: 0;
  }

  .adsure-mosaic-toggle-row .form-check-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.88rem;
    font-weight: 600;
  }

  .adsure-mosaic-toggle-row .form-check-input:checked {
    background-color: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .adsure-mosaic-control-meta {
    color: #66707d;
    font-size: 0.76rem;
    line-height: 1.35;
    margin-top: 10px;
  }

  .adsure-mosaic-control-error {
    color: ${LG_COLOR};
    font-size: 0.78rem;
    font-weight: 600;
    margin-top: 10px;
  }

  .adsure-panel {
    overflow: hidden;
  }

  .adsure-tabs.nav-tabs {
    background: ${SOFT_GREY_COLOR};
    border-bottom: 1px solid #d9dde3;
    padding: 10px 10px 0;
  }

  .adsure-tabs.nav-tabs .nav-link {
    border: 1px solid transparent;
    border-radius: 8px 8px 0 0;
    color: ${GRAPHITE_COLOR};
    font-weight: 600;
    margin-right: 4px;
    min-height: 42px;
  }

  .adsure-tabs.nav-tabs .nav-link.active {
    background: #fff;
    border-color: #d9dde3 #d9dde3 #fff;
    color: ${LG_COLOR};
  }

  .adsure-tab-body {
    padding: 18px;
  }

  .adsure-card {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 5px 16px rgba(65, 70, 80, 0.06);
  }

  .adsure-card-body {
    padding: 18px;
  }

  .adsure-section-label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.84rem;
    font-weight: 600;
    margin-bottom: 8px;
    white-space: nowrap;
  }

  .adsure-source-icon {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    height: 28px;
    justify-content: center;
    width: 28px;
  }

  .adsure-source-chip {
    align-items: center;
    background: #f8f9fb;
    border: 1px solid #dde2e8;
    border-radius: 8px;
    display: inline-flex;
    gap: 8px;
    padding: 8px 10px;
  }

  .adsure-pill-button {
    border-radius: 8px;
    font-weight: 600;
  }

  .adsure-pod-accordion .accordion-item {
    background: transparent;
    border: 0;
    margin-bottom: 12px;
  }

  .adsure-pod-accordion-header {
    position: relative;
  }

  .adsure-pod-accordion .accordion-button {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 8px !important;
    box-shadow: 0 5px 16px rgba(65, 70, 80, 0.06);
    color: ${GRAPHITE_COLOR};
    padding: 16px 148px 16px 18px;
  }

  .adsure-pod-accordion .accordion-button:not(.collapsed) {
    background: #fff;
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 6px 18px rgba(22, 81, 119, 0.12);
  }

  .adsure-pod-accordion .accordion-body {
    background: #fff;
    border: 1px solid #dde2e8;
    border-radius: 0 0 8px 8px;
    border-top: 0;
    padding: 18px;
  }

  .adsure-pod-status-actions {
    position: absolute;
    top: 50%;
    right: 18px;
    z-index: 5;
    display: flex;
    align-items: center;
    gap: 8px;
    transform: translateY(-50%);
  }

  .adsure-pod-status-actions .btn {
    min-width: 56px;
    border-radius: 8px;
    font-weight: 600;
  }

  .adsure-meta-grid {
    background: #f8f9fb;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    display: grid;
    gap: 16px;
    grid-template-columns:
      minmax(280px, 1.3fr)
      minmax(320px, 1.4fr)
      minmax(220px, 0.9fr);
    margin-bottom: 18px;
    padding: 14px;
  }

  @media (max-width: 992px) {
    .adsure-pod-accordion .accordion-button {
      padding: 16px 18px;
    }

    .adsure-pod-status-actions {
      position: static;
      justify-content: flex-end;
      padding: 10px 18px 0;
      transform: none;
    }
  }

  .adsure-meta-field {
    min-width: 0;
    overflow-wrap: normal;
    word-break: normal;
  }

  .adsure-meta-value {
    line-height: 1.45;
    overflow-wrap: normal;
    white-space: normal;
    word-break: normal;
  }

  .adsure-table-scroll {
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    max-height: 440px;
    overflow: auto;
  }

  .adsure-table-scroll table {
    min-width: 1240px;
  }

  .adsure-table-scroll thead th {
    background: #f3f5f8;
    border-bottom: 1px solid #d9dde3;
    color: ${GRAPHITE_COLOR};
    font-size: 0.78rem;
    position: sticky;
    text-transform: uppercase;
    top: 0;
    z-index: 1;
  }

  .adsure-table-scroll th,
  .adsure-table-scroll td {
    white-space: nowrap;
  }

  .adsure-table-scroll .adsure-country-column {
    min-width: 110px;
    text-align: left;
    white-space: nowrap;
    width: 110px;
  }

  .adsure-chart-frame {
    background: #f8f9fb;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    height: 340px;
    padding: 10px;
  }

  .adsure-donut-card .adsure-card-body {
    display: flex;
    flex-direction: column;
    min-height: 474px;
  }

  .adsure-donut-content {
    flex: 1;
  }

  .adsure-donut-frame {
    height: 340px;
    position: relative;
  }

  .adsure-donut-frame .recharts-responsive-container {
    height: 100%;
  }

  .adsure-donut-side {
    display: flex;
    flex-direction: column;
    height: 340px;
    min-height: 0;
  }

  .adsure-donut-frame-caption {
    color: #66707d;
    font-size: 0.82rem;
    font-weight: 600;
    left: 12px;
    overflow-wrap: anywhere;
    position: absolute;
    right: 12px;
    text-align: center;
    top: 10px;
    z-index: 1;
  }

  .adsure-donut-controls {
    margin-top: auto;
    padding-top: 12px;
  }

  .adsure-chart-tooltip {
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid #dde2e8;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(65, 70, 80, 0.16);
    padding: 10px 12px;
  }

  .adsure-donut-legend-item {
    align-items: center;
    background: #fff;
    border: 1px solid #e3e7ec;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    padding: 9px 10px;
  }

  .adsure-summary-value {
    color: ${MAIN_BLUE_COLOR};
    font-size: 1.55rem;
    font-weight: 700;
    overflow-wrap: anywhere;
  }

  .adsure-loading-state {
    align-items: center;
    color: #66707d;
    display: flex;
    justify-content: center;
    min-height: 180px;
  }

  @media (max-width: 991px) {
    padding: 16px;

    .adsure-monitoring-header {
      padding: 18px;
    }

    .adsure-header-controls {
      flex-direction: column;
      width: 100%;
    }

    .adsure-mosaic-control {
      min-width: 0;
      width: 100%;
    }

    .adsure-header-metric {
      border-left: 0;
      border-top: 1px solid ${PLATINUM_COLOR};
      min-width: 0;
      padding-left: 0;
      padding-top: 16px;
      width: 100%;
    }

    .adsure-tab-body {
      padding: 14px;
    }

    .adsure-chart-frame {
      height: 300px;
    }

    .adsure-meta-grid {
      grid-template-columns: 1fr;
    }

    .adsure-donut-card .adsure-card-body {
      min-height: 0;
    }

    .adsure-donut-side {
      height: auto;
    }
  }

  @media (max-width: 575px) {
    padding: 12px;

    .adsure-monitoring-title {
      font-size: 1.35rem;
    }

    .adsure-tabs.nav-tabs {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
    }

    .adsure-tabs.nav-tabs .nav-link {
      white-space: nowrap;
    }
  }
`;
